module.exports = __webpack_public_path__ + "static/img/bg.9fafa4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appRecommend/bg.png
// module id = 05Oi
// module chunks = 2